const ENV = process.env.REACT_APP_ENV || 'dev'

export const log = (message, data = {}, src = '') => {
  if (['stage', 'dev'].includes(ENV.toLowerCase())) {
    const logObj = {
      ...(typeof message === 'string' ? { msg: message } : message),
      src,
      data
    };
    console.log(logObj);
  }
};